import React, { useEffect, useState, useCallback } from "react";
import ProductCard from "./ProductCard";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useMyGlobal } from "./GlobalData";
import { Col, Container, Row, Image } from "react-bootstrap";
import { Button, Dimmer, Divider, Placeholder } from "semantic-ui-react";
import noDataImg from "../assets/no_data.png";

const idCustomer = JSON.parse(localStorage.getItem("loginData") || "{}")?.id || null;

const SuggestedProducts = ({ idCategory, exclude = '' }) => {
    const navigate = useNavigate();
    const { token, windowWidth } = useMyGlobal();
    const [prdDsc, setPrdDsc] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [noData, setNoData] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const limit = 6;
    const [loadMoreSpiner, setLoadMoreSpiner] = useState(false);
    const [loadMoreDisable, setLoadMoreDisable] = useState(false);
    const [labelState, setLabelState] = useState("Load More");
    const [hasMore, setHasMore] = useState(true);

    const getProductDiscount = useCallback(async () => {
        if (!idCategory) return;
        setIsLoading(true)
        setLoadMoreSpiner(true);
        setLoadMoreDisable(true);

        const param = new FormData()
        param.append("id_category", idCategory ?? 6);
        param.append("id_customer", idCustomer ?? false);
        param.append("page", currentPage);
        param.append("exclude", exclude ?? '')
        param.append("limit", limit);
        param.append("is_random", 1);

        try {
            const res = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=270`,
                headers: {
                    "Content-Type": "text/plain",
                    "Authorization": token,
                },
                data: param,
            });

            if (res.data.state === 200 && res.data.data.length > 0) {
                const newData = res.data.data;
                setPrdDsc([])

                setPrdDsc(prev => [
                    ...prev,
                    ...newData.filter(
                        item => !prev.some(prevItem => prevItem.id_product === item.id_product)
                    ),
                ]);

                setLoadMoreSpiner(false);
                setLoadMoreDisable(false);
                setHasMore(true);
                setNoData(false);

            } else {
                if (currentPage === 0) setNoData(true);
                setHasMore(false);
                setLoadMoreDisable(true);
                setLabelState("That's the last line for discounted product");
            }
        } catch (error) {
            //console.log("API ERROR:", error);
            setHasMore(false);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 5000);
            setLoadMoreSpiner(false);
        }
    }, [idCategory, exclude]);

    useEffect(() => {
        if (idCategory || exclude) {
            setCurrentPage(0);
            setPrdDsc([]);
            getProductDiscount();
        }
    }, [idCategory, exclude]);

    useEffect(() => {
        //console.log(`isLoading: ${isLoading}`)
    }, [isLoading]);

    return (
        <Container style={{ minHeight: "65vh", marginTop: "12vh" }}>
            <h3 className="display-10">RELATED PRODUCTS</h3>

            {windowWidth > 600 ? (
                <Divider horizontal>
                    <h6 className="fs-6">see if there are products you looking for</h6>
                </Divider>
            ) : (
                <p className="text-uppercase fw-bold">
                    <h6 style={{ fontSize: "0.9em" }}>
                        see if there are products you looking for
                    </h6>
                </p>
            )}

            {isLoading ? (
                <>
                <Row className="d-flex justify-content-center mb-3 mt-3">
                    {[...Array(6)].map((_, i) => (
                        <Col key={i} className="text-start mt-3" xxl={2} xl={2} lg={3} md={3} sm={4} xs={6}>
                            <div className="shimmer-box" style={{ background: "#999", padding: 10, borderRadius: 8, width: '100%' }}>
                                <Placeholder>    
                                    <Placeholder.Header>
                                        <Placeholder.Image square />
                                    </Placeholder.Header>
                                    <Placeholder.Paragraph>
                                        <Placeholder.Line />
                                        <Placeholder.Line length="short" />
                                        <Placeholder.Line length="very short" />
                                        <Placeholder.Line length="short" />
                                        <Placeholder.Line length="long" />
                                    </Placeholder.Paragraph>
                                </Placeholder>
                            </div>
                        </Col>
                    ))}
                </Row>
                </>
            ) : (
                /* Jika tidak loading → tampilkan produk */
                <Row className="d-flex justify-content-start mb-3 mt-3">
                    {noData && (
                        <div className="mt-3" style={{ display: "block" }}>
                            <Image src={noDataImg} width={200} height={200} />
                        </div>
                    )}

                    {prdDsc.map((item, i) => (
                        <ProductCard data={item} key={i} option="related" />
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default SuggestedProducts;
